<template>
  <v-container>
    <v-layout column>
      <v-autocomplete
        :name="Math.random()"
        v-model="campaignId"
        :items="campaignList"
        item-value="id"
        label="Select Campaign id"
        required
        :rules="[(v) => !!v || 'Please select a campaign']"
        @change="checkComment()"
      ></v-autocomplete>
    </v-layout>
    <v-layout column>
      <v-textarea
        clearable
        v-model="campaignComment"
        label="Enter Campaign Info"
        type="text"
        color="black"
        counter="1000"
      ></v-textarea>
    </v-layout>
    <v-layout column class="upload-logo">
      <p>Upload Brand Logo</p>
      <input ref="logoInput" accept=".jpg, .jpeg, .png" type="file" name="fileUpload" />
      <img ref="logo" src="" alt="there is no logo for this campaign" />
    </v-layout>
    <v-layout column>
      <v-btn
        @click="isEditMode ? editComment() : postComment()"
        class="submit-btn"
        >Submit</v-btn
      >
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import { mapActions, mapGetters, mapFields } from "vuex";

export default {
  components: {},
  data() {
    return {
      isEditMode: false,
      campaignId: "",
      campaignComment: "",
      commentId: -1,
    };
  },
  computed: {
    ...mapGetters(["userToken", "selectedDashboard"]),
    campaignList() {
      return Object.keys(this.selectedDashboard.campaigns);
    },
  },
  methods: {
    async postComment() {
      const formData = {
        userToken: this.userToken,
        campaignId: this.campaignId,
      };
      if (this.campaignComment) {
        formData.text = this.campaignComment;
      }
      const imageUrl = await this.uploadAsset(
        `comments/${this.campaignId}/image`
      );
      if (imageUrl.file) {
        formData.image = imageUrl.file;
      }
      axios.post(`${this.selectedDashboard.endPoints.base}/comments`, formData);
      alert('COMMENT IS POSTED SUCCESSFULLY')
    },
    async editComment() {
      const formData = {
        userToken: this.userToken,
      };
      formData.text = this.campaignComment ? this.campaignComment : 'there is no text for this campaign'
      const imageUrl = await this.uploadAsset(
        `comments/${this.campaignId}/image`
      );
      if (imageUrl.file) {
        formData.image = imageUrl.file;
      }
      axios.put(
        `${this.selectedDashboard.endPoints.base}/comments/${this.commentId}`,
        formData
      );
      alert('COMMENT IS EDITED SUCCESSFULLY')
    },
    checkComment() {
      axios
        .get(
          `${this.selectedDashboard.endPoints.base}/comments?campaignId=${this.campaignId}&userToken=${this.userToken}`
        )
        .then((response) => {
          if (response.data.result) {
            this.isEditMode = true;
            this.campaignComment = response.data.result.text || "";
            this.commentId = response.data.result.id;
            this.$refs.logo.src = response.data.result.image || "";
          } else {
            this.isEditMode = false;
            this.campaignComment = "";
            this.commentId = -1;
            this.$refs.logo.src = ""
          }
        });
    },
    async uploadAsset(name) {
      const formData = new FormData();
      const file = document.querySelector(
        `input[type="file"][name="fileUpload"]`
      ).files[0];
      if (!file) return { file: "" };

      formData.append("name", name);
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        axios
          .post(
            "https://template-v2.justsnap.eu/api/template/uploadAsset",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            if (res.data.result === "OK") resolve(res.data);
            else reject(res.data);
          });
      });
    },
  },
  mounted() {
    this.$refs.logoInput.onchange = () => {
      if(this.$refs.logoInput.files[0]){
        this.$refs.logo.src = URL.createObjectURL(this.$refs.logoInput.files[0])
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.submit-btn {
  background-color: black !important;
  color: white !important;
  border: 1px solid white;
  margin: 40px auto;
}

.upload-logo {
  margin-top: 40px;
  p {
    font-weight: bold;
  }
}

img {
  height: auto;
  width: 200px;
  margin: 0 auto;
  padding: 30px;
  border: 1px solid black;
}
</style>
